export const getCurrentPosition = (options?: PositionOptions): Promise<GeolocationPosition> =>
  new Promise((resolve, reject) => {
    const { geolocation } = navigator;

    if (!geolocation) {
      return reject();
    }

    geolocation.getCurrentPosition(resolve, reject, options);
  });
